import { css } from '@/styled-system/css';

export const gridContentStyles = css.raw({
  gridColumnEnd: { base: 'span 4', mdDown: 'span 12' },
  padding: '400',
  border: `1px solid {colors.border.subtle}`,
  textAlign: 'center',
});
